export default __webpack_public_path__ + "alberta-foto.8fb94d38b03c2bbef62f.svg";